import * as React from "react";
import "./bootstrap.min.css";
import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import FrameGate from "./FrameGate";
import { store } from "./store";
import { createRoot } from "react-dom/client";
import { HashRouter as BrowserRouter } from "react-router-dom";
import "./i18n";
import { captureReferral } from "./utils/referral";

// Before anything renders: a screen that redirects on load (to the login, say)
// would otherwise drop the ?ref from the address before it could be saved.
captureReferral();

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <FrameGate>
        <App />
      </FrameGate>
    </BrowserRouter>
  </Provider>,
);
